import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import ClassifierTable from 'src/routes/settings/classifiers/ClassifierTable';
import useStyles from 'src/styles/di-theme';
import classNames from 'classnames';
import { usePageTitle } from 'src/hooks/useMastheadTitle';

function ClassifierSettings(): ReactElement {
	usePageTitle('Classifiers');
	const { auth } = useAuth();
	const classes = useStyles();
	if (!auth?.isFullAdmin()) {
		return <Navigate to="/settings/" />;
	}

	return (
		<div
			className={classNames(
				classes['pt_4'],
				classes['plr_4'],
				classes['m_auto']
			)}
		>
			<ClassifierTable accountId={auth.accountDetails.account.id} />
		</div>
	);
}

export default ClassifierSettings;
